import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { XSellingDialog as XSellingDialogBase } from "@jti/ui";
import { useConfig } from "@jti/ui/providers/useConfig";
import { XSellingDialogEvents } from "./events";
export const XSellingDialog = (props) => {
    const { CART_CHECKOUT_PAGE_URL } = useConfig();
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        const { signal, abort } = new AbortController();
        window.addEventListener(XSellingDialogEvents.open, () => setIsOpen(true), { signal });
        return () => abort();
    }, []);
    const redirectToCheckout = () => window.location.assign(CART_CHECKOUT_PAGE_URL);
    return isOpen && _jsx(XSellingDialogBase, { ...props, isOpened: isOpen, onClose: redirectToCheckout });
};
//# sourceMappingURL=XSellingDialog.js.map